// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Fuel/font/digital-7.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*media breaks*/
@font-face {
  font-family: "digital-clock-font";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@keyframes pulse {
  0% {
    transform: scale(0.9);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(44, 83, 160, 0.3);
  }
  100% {
    transform: scale(0.9);
    box-shadow: 0 0 0 0 rgba(44, 83, 160, 0.1);
  }
}
@keyframes pulse_1 {
  0% {
    transform: scale(1.4);
  }
  50% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1.4);
  }
}
.mobile_message {
  display: none;
}

@media (max-width: 1200px) {
  .mobile_message {
    display: flex;
  }
  .rota_mobile_toggle {
    display: none;
  }
}
.staff__management {
  margin-left: 12%;
  width: 100%;
  min-height: 81vh;
  margin-top: -30px;
}
.staff__management .top_bar {
  width: 88%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: -10px;
}
.staff__management .top_bar .top_bar_left {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 50%;
}
.staff__management .top_bar .top_bar_left select {
  width: 30%;
  border-radius: 5px;
  border: 1px solid #2c53a0;
  height: 2rem;
}
.staff__management .top_bar .top_bar_left h2 {
  width: 70%;
  margin-left: 10px;
}
.staff__management .top_bar .top_bar_left h2 span {
  color: #2c53a0;
}
.staff__management .top_bar .filter_section {
  display: flex;
  gap: 0.25vh;
  flex-direction: column;
}
.staff__management .top_bar .filter_section select {
  width: 150px;
  border-radius: 5px;
  border: 1px solid #2c53a0;
  height: 1.2rem;
}
.staff__management .top_bar .top_bar_right {
  display: flex;
  justify-content: flex-end;
  height: 50px;
  margin-bottom: 10px;
}
.staff__management .top_bar .top_bar_right .key_section {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.staff__management .top_bar .top_bar_right .css-7dv1rb-MuiButtonBase-root-MuiFab-root-MuiSpeedDial-fab {
  background-color: #32a868;
  border-radius: 6px;
  width: 64px;
  height: 50px;
  margin-top: 30px;
  margin-left: 10px;
}
.staff__management .top_bar .top_bar_right .MuiSpeedDial-fab {
  background-color: #32a868;
  border-radius: 6px;
  width: 64px;
  height: 50px;
}
.staff__management .top_bar .top_bar_right button {
  border-radius: 6px;
  margin-left: 10px;
  margin-right: 0;
}
.staff__management .top_bar .top_bar_right .print_btn button {
  height: 50px;
}
.staff__management .top_bar .top_bar_right .pulse-button {
  -webkit-animation: pulse 2s infinite;
}
.staff__management .top_bar .top_bar_right .republish_btn {
  margin-right: 100px;
}
.staff__management .top_bar .top_bar_right .rota_note_icon {
  animation: pulse_1 2s infinite;
}
.staff__management .bottom_bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 88%;
  margin: 0;
  margin-top: 10px;
}
.staff__management .bottom_bar .mid_bar_left {
  width: 100%;
}
.staff__management .bottom_bar .mid_bar_left #add_employee_label {
  margin: 0;
}
.staff__management .bottom_bar .mid_bar_left .add_employee select {
  width: 300px;
  border-radius: 5px;
  padding: 0 4px;
  border: 1px solid #2c53a0;
  height: 2rem;
  margin-right: 20px;
}
.staff__management .bottom_bar .mid_bar_left .add_employee button {
  border-radius: 8px;
  padding: 4px 4px;
}
.staff__management .bottom_bar .mid_bar_left #employeeId_alert {
  width: 40%;
}
.staff__management .bottom_bar .mid_bar_right {
  display: flex;
  justify-content: flex-end;
}
.staff__management .arrow_key_bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 88%;
  margin-bottom: 8px;
}
.staff__management .rota_main::-webkit-scrollbar {
  border-radius: 0;
  width: 8px;
}
.staff__management .rota_main::-webkit-scrollbar-track {
  border-radius: 0;
  width: 5px;
}
.staff__management .rota_main::-webkit-scrollbar-thumb {
  border-radius: 0;
  width: 5px;
}
.staff__management .rota_main {
  max-width: 88%;
  overflow-y: scroll;
  height: 68vh;
}
.staff__management .rota_main table {
  table-layout: fixed;
  background-color: #fff;
  border-collapse: collapse;
  color: #4d4d4d;
  width: 100%;
}
.staff__management .rota_main table thead {
  border-bottom: 1px solid #4d4d4d;
  text-align: center;
}
.staff__management .rota_main table tbody {
  text-align: center;
}
.staff__management .rota_main table tbody tr {
  border-bottom: 1px solid #4d4d4d;
}
.staff__management .rota_main table tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}
.staff__management .rota_main table tbody tr input {
  width: 20%;
  margin: 0 auto;
  text-align: center;
}
.staff__management .rota_main table .confirm_row .empty_cell {
  background-color: #e4ffff;
}
.staff__management .rota_main table .confirm_row .confirm_day_btn {
  margin: 5px 0;
  padding: 1px 8px;
}
.staff__management .rota_main table .employee_row .name_cell p {
  margin: 3px 0;
}
.staff__management .rota_main table .employee_row .name_cell .staff_name {
  font-weight: 700;
}
.staff__management .rota_main table .employee_row .name_cell .staff_position {
  color: #2c53a0;
  font-weight: 500;
}
.staff__management .rota_main table .employee_row .name_cell .hours_worked {
  font-size: 0.8rem;
}
.staff__management .rota_main table .employee_row .name_cell .hours_worked span {
  color: #2c53a0;
}
.staff__management .rota_main table .employee_row .shift_cell .add_shift_btn {
  width: 40px;
  height: 55px;
  border-radius: 50%;
  background-color: rgba(44, 83, 160, 0.2);
  margin: 10px 0;
}
.staff__management .rota_main table .employee_row .shift_cell .add_shift_btn:hover {
  background-color: rgba(44, 83, 160, 0.7);
}
.staff__management .rota_main table .employee_row .shift_cell .shift_time {
  font-weight: 500;
  margin: 3px;
  color: #000;
}
.staff__management .rota_main table .employee_row .shift_cell .extra_shift_btn {
  width: 10px;
  height: 20px;
  background-color: rgba(44, 83, 160, 0.2);
  margin: 10px 0;
}
.staff__management .rota_main table .employee_row .shift_cell .extra_shift_btn:hover {
  background-color: rgba(44, 83, 160, 0.7);
}

#modal_alert {
  font-weight: 800;
  color: #bb0000;
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  display: none;
}

.publish_modal .publish_btns {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}

.printable_rota {
  background-color: #fff;
}
.printable_rota table {
  border: black;
  border-collapse: collapse;
  width: 98%;
  margin: 0 auto;
  margin-bottom: 2vh;
}
.printable_rota table thead tr th {
  border: 1px solid black;
  color: #000;
}
.printable_rota table tbody tr {
  margin: 0;
  padding: 0;
}
.printable_rota table tbody tr td {
  border: 1px solid black;
  color: #000;
  text-align: center;
  font-size: 0.8rem;
  font-weight: 600;
}
.printable_rota .header_section {
  display: flex;
  justify-content: start;
  align-items: center;
  margin-bottom: 1vh;
}
.printable_rota .header_section button {
  width: 150px;
  height: 5vh;
  margin: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/variables.scss","webpack://./src/components/holidays/rotas/rota.scss"],"names":[],"mappings":"AAOA,eAAA;AAeA;EACI,iCAAA;EACA,4CAAA;ACpBJ;AAFA;EACE;IACE,qBAAA;EAIF;EAFA;IACE,mBAAA;IACA,6CAAA;EAIF;EAFA;IACE,qBAAA;IACA,0CAAA;EAIF;AACF;AADA;EACE;IACE,qBAAA;EAGF;EAAA;IACE,qBAAA;EAEF;EAAA;IACE,qBAAA;EAEF;AACF;AACA;EACE,aAAA;AACF;;AAEA;EACE;IACE,aAAA;EACF;EACA;IACE,aAAA;EACF;AACF;AAEA;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AAAF;AAEE;EACE,UAAA;ED8DA,aAAA;EACA,mBAAA;EACA,8BAAA;EC9DA,oBAAA;AAEJ;AAAI;ED4EA,aAAA;EACA,mBAAA;EACA,2BAAA;EApBA,aAAA;EACA,mBAAA;EACA,8BAAA;ECnDE,UAAA;AAAN;AAPM;EACE,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;AASR;AAJM;EACE,UAAA;EACA,iBAAA;AAMR;AALQ;EACE,cDpEE;AC2EZ;AAFI;EACE,aAAA;EACA,WAAA;EACA,sBAAA;AAIN;AAFM;EACE,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;AAIR;AAAI;EACE,aAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;AAEN;AAAM;EDmBF,aAAA;EACA,mBAAA;EACA,8BAAA;AChBJ;AADM;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AAGR;AADM;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAGR;AAAM;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;AAER;AAEQ;EACE,YAAA;AAAV;AAIM;EACE,oCAAA;AAFR;AAIM;EACE,mBAAA;AAFR;AAKM;EACE,8BAAA;AAHR;AAQE;EDzBE,aAAA;EACA,mBAAA;EACA,8BAAA;ECyBA,UAAA;EACA,SAAA;EACA,gBAAA;AAJJ;AAKI;EACE,WAAA;AAHN;AAIM;EACE,SAAA;AAFR;AAKQ;EACE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;AAHV;AAKQ;EACE,kBAAA;EACA,gBAAA;AAHV;AAMM;EACE,UAAA;AAJR;AAQI;EAEE,aAAA;EACA,yBAAA;AAPN;AAWE;ED7DE,aAAA;EACA,mBAAA;EACA,8BAAA;EC6DA,UAAA;EACA,kBAAA;AAPJ;AAUE;EACE,gBAAA;EACA,UAAA;AARJ;AAWE;EACE,gBAAA;EACA,UAAA;AATJ;AAYE;EACE,gBAAA;EACA,UAAA;AAVJ;AAaE;EACE,cAAA;EACA,kBAAA;EACA,YAAA;AAXJ;AAaI;ED/DA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAvIQ;ECqMN,WAAA;AARN;ADrDI;EACI,gCAAA;EACA,kBAAA;ACuDR;ADrDI;EACI,kBAAA;ACuDR;ADtDQ;EACI,gCAAA;ACwDZ;ADvDY;EACI,yBAAA;ACyDhB;ADvDY;EACI,UAAA;EACA,cAAA;EACA,kBAAA;ACyDhB;AAPQ;EACE,yBD1MG;ACmNb;AANQ;EACE,aAAA;EACA,gBAAA;AAQV;AAFU;EACE,aAAA;AAIZ;AAFU;EACE,gBAAA;AAIZ;AAFU;EACE,cD9NA;EC+NA,gBAAA;AAIZ;AADU;EACE,iBAAA;AAGZ;AAFY;EACE,cDrOF;ACyOZ;AACU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wCAAA;EACA,cAAA;AACZ;AAEU;EACE,wCAAA;AAAZ;AAGU;EACE,gBAAA;EACA,WAAA;EACA,WAAA;AADZ;AAIU;EACE,WAAA;EACA,YAAA;EACA,wCAAA;EACA,cAAA;AAFZ;AAKU;EACE,wCAAA;AAHZ;;AAWA;EACE,gBAAA;EACA,cD1QM;EC2QN,gEAAA;EACA,aAAA;AARF;;AAYE;EDrKE,aAAA;EACA,mBAAA;EACA,8BAAA;ECqKA,gBAAA;AAPJ;;AAWA;EACE,sBAAA;AARF;AAUE;EACE,aAAA;EACA,yBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;AARJ;AAYQ;EACE,uBAAA;EACA,WAAA;AAVV;AAeM;EACE,SAAA;EACA,UAAA;AAbR;AAcQ;EACE,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AAZV;AAiBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AAfJ;AAgBI;EACE,YAAA;EACA,WAAA;EACA,YAAA;AAdN","sourcesContent":["$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n\n/*media breaks*/\n$mobile: 600px;\n$tablet: 768px;\n$laptop: 900px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@font-face {\n    font-family: \"digital-clock-font\";\n    src: url(\"./Fuel/font/digital-7.ttf\");\n}\n\n@mixin shadow {\n    box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n@mixin card {\n    background-color: #fff;\n    @include shadow;\n    border-radius: 1rem;\n}\n\n@mixin alertCard {\n    box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px,\n        rgba(0, 0, 0, 0.23) 0px 6px 6px;\n    background-color: #fff;\n    border-radius: 0.5rem;\n}\n\n@mixin eposCard {\n    background-color: #fff;\n    box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px,\n        rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px,\n        rgba(0, 0, 0, 0.09) 0px 32px 16px;\n}\n\n@mixin flex($d: row, $j: center, $a: center, $g: 1vw) {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: $d;\n    justify-content: $j;\n    align-items: $a;\n    gap: $g;\n}\n\n@mixin columnStack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnStart {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n@mixin columnAlignStart {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin columnAlignStartTop {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin rowEven {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n}\n\n@mixin rowEvenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n@mixin rowEvenStartCenter {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n}\n@mixin rowBetween {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin table {\n    table-layout: fixed;\n    background-color: #fff;\n    border-collapse: collapse;\n    color: $fontColor;\n    thead {\n        border-bottom: 1px solid $fontColor;\n        text-align: center;\n    }\n    tbody {\n        text-align: center;\n        tr {\n            border-bottom: 1px solid $fontColor;\n            &:nth-child(odd) {\n                background-color: #f2f2f2;\n            }\n            input {\n                width: 20%;\n                margin: 0 auto;\n                text-align: center;\n            }\n        }\n    }\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 50vh;\n    background-color: #fff;\n    border: 2px solid #000;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 600px) {\n        width: 95vw;\n    }\n}\n","@import \"../../variables.scss\";\n\n@keyframes pulse {\n  0% {\n    transform: (scale(0.9));\n  }\n  70% {\n    transform: (scale(1));\n    box-shadow: 0 0 0 10px rgba($nitroDark, 0.3);\n  }\n  100% {\n    transform: (scale(0.9));\n    box-shadow: 0 0 0 0 rgba(rgba($nitroDark, 0.3), 0.1);\n  }\n}\n\n@keyframes pulse_1 {\n  0% {\n    transform: scale(1.4);\n  }\n\n  50% {\n    transform: (scale(0.9));\n  }\n  100% {\n    transform: scale(1.4);\n  }\n}\n\n.mobile_message {\n  display: none;\n}\n\n@media (max-width: 1200px) {\n  .mobile_message {\n    display: flex;\n  }\n  .rota_mobile_toggle {\n    display: none;\n  }\n}\n\n.staff__management {\n  margin-left: 12%;\n  width: 100%;\n  min-height: 81vh;\n  margin-top: -30px;\n\n  .top_bar {\n    width: 88%;\n    @include rowBetween;\n    margin-bottom: -10px;\n\n    .top_bar_left {\n      @include rowStart;\n      select {\n        width: 30%;\n        border-radius: 5px;\n        border: 1px solid $nitroDark;\n        height: 2rem;\n      }\n      @include rowBetween;\n      width: 50%;\n\n      h2 {\n        width: 70%;\n        margin-left: 10px;\n        span {\n          color: $nitroDark;\n        }\n      }\n    }\n\n    .filter_section {\n      display: flex;\n      gap: 0.25vh;\n      flex-direction: column;\n\n      select {\n        width: 150px;\n        border-radius: 5px;\n        border: 1px solid $nitroDark;\n        height: 1.2rem;\n      }\n    }\n\n    .top_bar_right {\n      display: flex;\n      justify-content: flex-end;\n      height: 50px;\n      margin-bottom: 10px;\n\n      .key_section {\n        @include rowBetween;\n      }\n\n      .css-7dv1rb-MuiButtonBase-root-MuiFab-root-MuiSpeedDial-fab {\n        background-color: #32a868;\n        border-radius: 6px;\n        width: 64px;\n        height: 50px;\n        margin-top: 30px;\n        margin-left: 10px;\n      }\n      .MuiSpeedDial-fab {\n        background-color: #32a868;\n        border-radius: 6px;\n        width: 64px;\n        height: 50px;\n      }\n\n      button {\n        border-radius: 6px;\n        margin-left: 10px;\n        margin-right: 0;\n      }\n\n      .print_btn {\n        button {\n          height: 50px;\n        }\n      }\n\n      .pulse-button {\n        -webkit-animation: pulse 2s infinite;\n      }\n      .republish_btn {\n        margin-right: 100px;\n      }\n\n      .rota_note_icon {\n        animation: pulse_1 2s infinite;\n      }\n    }\n  }\n\n  .bottom_bar {\n    @include rowBetween;\n    width: 88%;\n    margin: 0;\n    margin-top: 10px;\n    .mid_bar_left {\n      width: 100%;\n      #add_employee_label {\n        margin: 0;\n      }\n      .add_employee {\n        select {\n          width: 300px;\n          border-radius: 5px;\n          padding: 0 4px;\n          border: 1px solid $nitroDark;\n          height: 2rem;\n          margin-right: 20px;\n        }\n        button {\n          border-radius: 8px;\n          padding: 4px 4px;\n        }\n      }\n      #employeeId_alert {\n        width: 40%;\n      }\n    }\n\n    .mid_bar_right {\n      // width: 100%;\n      display: flex;\n      justify-content: flex-end;\n    }\n  }\n\n  .arrow_key_bar {\n    @include rowBetween;\n    width: 88%;\n    margin-bottom: 8px;\n  }\n\n  .rota_main::-webkit-scrollbar {\n    border-radius: 0;\n    width: 8px;\n  }\n\n  .rota_main::-webkit-scrollbar-track {\n    border-radius: 0;\n    width: 5px;\n  }\n\n  .rota_main::-webkit-scrollbar-thumb {\n    border-radius: 0;\n    width: 5px;\n  }\n\n  .rota_main {\n    max-width: 88%;\n    overflow-y: scroll;\n    height: 68vh;\n\n    table {\n      @include table;\n      width: 100%;\n\n      .confirm_row {\n        .empty_cell {\n          background-color: $background;\n        }\n\n        .confirm_day_btn {\n          margin: 5px 0;\n          padding: 1px 8px;\n        }\n      }\n\n      .employee_row {\n        .name_cell {\n          p {\n            margin: 3px 0;\n          }\n          .staff_name {\n            font-weight: 700;\n          }\n          .staff_position {\n            color: $nitroDark;\n            font-weight: 500;\n          }\n\n          .hours_worked {\n            font-size: 0.8rem;\n            span {\n              color: $nitroDark;\n            }\n          }\n        }\n        .shift_cell {\n          .add_shift_btn {\n            width: 40px;\n            height: 55px;\n            border-radius: 50%;\n            background-color: rgba($nitroDark, 0.2);\n            margin: 10px 0;\n          }\n\n          .add_shift_btn:hover {\n            background-color: rgba($nitroDark, 0.7);\n          }\n\n          .shift_time {\n            font-weight: 500;\n            margin: 3px;\n            color: #000;\n          }\n\n          .extra_shift_btn {\n            width: 10px;\n            height: 20px;\n            background-color: rgba($nitroDark, 0.2);\n            margin: 10px 0;\n          }\n\n          .extra_shift_btn:hover {\n            background-color: rgba($nitroDark, 0.7);\n          }\n        }\n      }\n    }\n  }\n}\n\n#modal_alert {\n  font-weight: 800;\n  color: $error;\n  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;\n  display: none;\n}\n\n.publish_modal {\n  .publish_btns {\n    @include rowBetween;\n    margin-top: 20px;\n  }\n}\n\n.printable_rota {\n  background-color: #fff;\n\n  table {\n    border: black;\n    border-collapse: collapse;\n    width: 98%;\n    margin: 0 auto;\n    margin-bottom: 2vh;\n\n    thead {\n      tr {\n        th {\n          border: 1px solid black;\n          color: #000;\n        }\n      }\n    }\n    tbody {\n      tr {\n        margin: 0;\n        padding: 0;\n        td {\n          border: 1px solid black;\n          color: #000;\n          text-align: center;\n          font-size: 0.8rem;\n          font-weight: 600;\n        }\n      }\n    }\n  }\n  .header_section {\n    display: flex;\n    justify-content: start;\n    align-items: center;\n    margin-bottom: 1vh;\n    button {\n      width: 150px;\n      height: 5vh;\n      margin: 10px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
